import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => (
  <div className="container mw-760 text-center">
    <div className="graphic-wrapper">
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <g data-name="Layer 57" id="Layer_57">
          <path
            className="cls-1"
            d="M16,31A15,15,0,1,1,31,16,15,15,0,0,1,16,31ZM16,3A13,13,0,1,0,29,16,13,13,0,0,0,16,3Z"
          />
          <path
            className="cls-1"
            d="M16,24a2,2,0,1,1,2-2A2,2,0,0,1,16,24Zm0-2Z"
          />
          <path
            className="cls-1"
            d="M16,18a1,1,0,0,1-1-1V8a1,1,0,0,1,2,0v9A1,1,0,0,1,16,18Z"
          />
        </g>
      </svg>
    </div>
    <h2 className="mb-4">
      <span className="text-link-alt">Error 404</span> -{" "}
      <small>The page does not exist</small>
    </h2>
    <p className="text-left mb-4">
      The page you are looking for may have been removed. If you followed a
      valid link from within the application
    </p>
    Back to{" "}
    <Link className="link-color" to="/">
      Organizations
    </Link>{" "}
  </div>
);
export default PageNotFound;
